"use strict";

/**
 * Add push script to the <head>
 */
;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);
  var scriptLoaded = false;

  /**
   * Check if this ad should be shown
   * @returns boolean
   */
  function isEnabled() {
    return Flix.ads.enabled
    /** Not organic user */ && !Flix.ads.isOrganic()
    /** Those mediabuys forbid push ads */ && [1, 8, 94].indexOf(Flix.ads.iid) == -1;
  }
  ;

  /**
   * Main logic
   */
  function onPageLoad() {
    if (scriptLoaded || !isEnabled()) {
      return;
    }
    scriptLoaded = true;
    if (Flix.isTna()) {
      window._izq = window._izq || [];
      window._izq.push(["init"]);
      var s = document.createElement('script');
      s.src = 'https://cdn.izooto.com/scripts/0daff41c37672618d6e4f2f836da59bb314427a6.js';
      s.type = 'text/javascript';
      s.async = true;
      s.onload = function () {
        setTimeout(function () {
          if (typeof _izooto != "undefined" && typeof _izooto.requestPermission != "undefined") {
            _izooto.requestPermission();
          }
        }, 750);
      };
      document.head.appendChild(s);
    } else {
      window._izq = window._izq || [];
      window._izq.push(["init"]);
      var s = document.createElement('script');
      s.src = 'https://cdn.izooto.com/scripts/9a8b3ca96aba6890645465e27fe82a7ed0e51ed1.js';
      document.head.appendChild(s);
    }
  }
  ;
})();